import { Button, Stack } from '@mui/material'
import { postRequest } from 'utils/api'
import { INVITED_LIST_URL, USER_ROLE_TYPES } from 'services/constants'
import { useState } from 'react'
import CommonDialog from 'components/molecules/notificationOverlay/CommonDialog'
import OverlayLoading from 'components/atoms/OverlayLoading'
import SuccessfulNotificationDialog from 'components/molecules/notificationOverlay/SuccessfulNotificationDialog'
import UserInviteForm from 'components/atoms/input/UserInviteForm'
import { useTranslation } from 'react-i18next'

const ImportContactsButton = ({ organizationId }) => {
  const { t } = useTranslation()
  const [invites, setInvites] = useState([])
  const [sendDialogOpen, setSendDialogOpen] = useState(false)
  const [successDialogOpen, setSuccessDialogOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [inviteError, setInviteError] = useState(false)

  const resetInviteForm = () => {
    setInvites([])
    setInviteError('')
  }

  const handleDialogSelect = async isSend => {
    if (!isSend) {
      setSendDialogOpen(false)
      resetInviteForm()
    } else {
      if (invites.length === 0) {
        setInviteError(t('company.enterValidEmailValidation'))
        return
      }
      setLoading(true)
      setSendDialogOpen(false)
      setInviteError('')

      const res = await postRequest(INVITED_LIST_URL, {
        invitees: invites,
        organizationId,
        userRole: USER_ROLE_TYPES.RESTRICTED,
        contactOnly: true
      })

      if (res.status === 201) {
        setSuccessDialogOpen(true)
        resetInviteForm()
      } else {
        setSendDialogOpen(true)
      }
      setLoading(false)
    }
  }

  return (
    <>
      <Button
        sx={{ width: 'fit-content' }}
        onClick={() => setSendDialogOpen(true)}
      >
        {t('company.importCompanyContacts')}
      </Button>
      <CommonDialog
        open={sendDialogOpen}
        titleText={t('company.importCompanyContacts')}
        onClose={handleDialogSelect}
        maxWidth='xl'
        confirmText={t('common.send')}
        cancelText={t('common.cancel')}
        buttonsDirection='row'
        errorAlertMessage={inviteError}
        bodyWidth={850}>
        <Stack sx={{ padding: 0, paddingTop: 10 }} spacing={4} width={800}>
          <UserInviteForm
            emails={invites}
            setEmails={setInvites}
            disabled={false}
            isSuperAdminView={true}
          />
        </Stack>
      </CommonDialog>
      <SuccessfulNotificationDialog
        open={successDialogOpen}
        titleText={t('company.companyContactsAdded')}
        confirmButtonText={t('common.done')}
        buttonAction={() => setSuccessDialogOpen(false)}
      />
      <OverlayLoading open={loading} />
    </>
  )
}

export default ImportContactsButton
